import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TurnosSignUpSelection from './TurnosSignUpSelection';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const TurnosSignUp = () => {
    const { state } = useLocation() as any;
    const navigate = useNavigate();
    const packageSelectRef = useRef<HTMLSelectElement>(null);
    const SideEventSelectRef = useRef<HTMLSelectElement>(null);
    const checkoutButtonRef = useRef<HTMLButtonElement>(null);
    const selectionRefs = useRef<Array<HTMLDivElement | null>>([]);
    const jugador = state?.jugador;
    const tournament = state?.tournament;
    const discountCode = state?.discountCode;
    const recruiterMode = state?.recruiterMode;
    const [groupCode, setGroupCode] = useState(discountCode || '');
    const [lockedDivision, setLockedDivision] = useState<any>(null);
	const [lockedPackage, setLockedPackage] = useState<any>(null);
    const [isMarathon, setIsMarathon] = useState(false);
    const [divisiones, setDivisiones] = useState<any[]>([]);
    const [paquetes, setPaquetes] = useState<any[]>([]);
    const [reEntries, setItems] = useState<any[]>([]);
    const [sideEvents, setSideItems] = useState<any[]>([]);
    // Array of selections: { division, package }
    const [selections, setSelections] = useState<{ division: any; package: any; item?: any }[]>([]);

    // For the current selection form
    const [selectedDivision, setSelectedDivision] = useState('');
    const [selectedPackage, setSelectedPackage] = useState('');
    const [selectedItem, setSelectedItem] = useState('');
    const [selectedSideEvent, setSelectedSideEvent] = useState('');

    // Collect completed selection data for each package
    const [completedSelections, setCompletedSelections] = useState<any[]>([]);
	
	const [shouldAnimateAddButton, setShouldAnimateAddButton] = useState(false);
    const addToCartButtonRef = useRef<HTMLButtonElement>(null);

    // Function to trigger button animation
    const animateAddToCartButton = () => {
        setShouldAnimateAddButton(true);
        if (addToCartButtonRef.current) {
            addToCartButtonRef.current.focus();
            addToCartButtonRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        setTimeout(() => {
            setShouldAnimateAddButton(false);
        }, 1000);
    };

    useEffect(() => {
        if (tournament?.clave) {
            fetch(`${BACKEND_URL}/api/divisiones?cvetorneo=${tournament.clave}&cvejugador=${jugador.FICHANAL}&cve=${jugador.CLAVE} `)
                .then(res => res.json())
                .then(data => setDivisiones(data));
            fetch(`${BACKEND_URL}/api/paquetes?cveTorneo=${tournament.clave}&discountCode=${groupCode || ''}`)
                .then(res => res.json())
                .then(data => setPaquetes(data));
            fetch(`${BACKEND_URL}/api/sideevents?cveTorneo=${tournament.clave}&discountCode=${groupCode || ''}`)
                .then(res => res.json())
                .then(data => setSideItems(data));
        }
    }, [tournament, groupCode]);

    useEffect(() => {
        if (tournament?.clave) {
            fetch(`${BACKEND_URL}/api/reentries?cveTorneo=${tournament.clave}&discountCode=${groupCode || ''}&marathon=${isMarathon}`)
                .then(res => res.json())
                .then(data => setItems(data));
        }
    }, [tournament, groupCode, isMarathon]);

    // Focus and animate checkout button when all selections are completed
    useEffect(() => {
        if (
            completedSelections.length === selections.length &&
            selections.length > 0 &&
            checkoutButtonRef.current
        ) {
            checkoutButtonRef.current.focus();
            checkoutButtonRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            checkoutButtonRef.current.classList.add('animate-bounce');
            setTimeout(() => {
                checkoutButtonRef.current?.classList.remove('animate-bounce');
            }, 700);
        }
    }, [completedSelections.length, selections.length]); // run when these change
	
	const checkMainPackage = () => {
        if (tournament?.clave && jugador?.CLAVE) {
            fetch(`${BACKEND_URL}/api/player-main-package/${tournament.clave}/${jugador.CLAVE}`)
                .then(res => res.json())
                .then(data => {
                    setIsMarathon(data.isMarathon || false);
                    if (data.hasMainPackage) {
                        setLockedPackage({ locked: true, reason: 'Player already has main package' });
                    } else {
                        // Only unlock if it was locked due to existing main package
                        if (lockedPackage?.reason === 'Player already has main package') {
                            setLockedPackage(null);
                        }
                    }
                })
                .catch(error => {
                    console.error('Error checking main package:', error);
                });
        }
    };

    // Your useEffect calls the function
    useEffect(() => {
        checkMainPackage();
    }, [tournament, jugador]);

    if (!jugador || !tournament) return <div>No data provided.</div>;

    const handleAddSelection = () => {
        const divisionObj = divisiones.find(d => String(d.CLAVE) === selectedDivision);
        // Only one of these will be set
        const packageObj = paquetes.find(p => String(p.CLAVE) === selectedPackage);
        const itemObj = reEntries.find(i => String(i.CLAVE) === selectedItem);
        const sideEventObj = sideEvents.find(s => String(s.CLAVE) === selectedSideEvent);

        // Use whichever
        const selectedPkg = packageObj || itemObj || sideEventObj;
		 if (packageObj && !lockedPackage) {
        setLockedPackage(packageObj);
    }

        if (divisionObj && selectedPkg) {
            setSelections(prev => {
                const newSelections = [
                    ...prev,
                    {
                        division: divisionObj,
                        package: selectedPkg
                    }
                ];
                // Scroll after state update
                setTimeout(() => {
                    const lastIdx = newSelections.length - 1;
                    const el = selectionRefs.current[lastIdx];
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }, 0);
                return newSelections;
            });
            setSelectedPackage('');
            setSelectedItem('');
            setSelectedSideEvent('');
            if (!lockedDivision) setLockedDivision(divisionObj);
        }
    };
    // Remove handler for a package
    const handleRemoveSelection = (idx: number) => {
    setSelections(selections => {
        const selectionToRemove = selections[idx];
        const updated = selections.filter((_, i) => i !== idx);
        
        // If no packages left, unlock division
        if (updated.length === 0) {
            setLockedDivision(null);
            setLockedPackage(null); // Also unlock package when no selections left
			setTimeout(() => checkMainPackage(), 0);
        } else {
            // Check if the removed selection was a package (not re-entry or side event)
            const wasPackage = paquetes.some(p => p.CLAVE === selectionToRemove.package.CLAVE);
            
            if (wasPackage) {
                // Check if any remaining selections are also packages
                const hasRemainingPackages = updated.some(sel => 
                    paquetes.some(p => p.CLAVE === sel.package.CLAVE)
                );
                
                // If no remaining packages, unlock the package constraint
                if (!hasRemainingPackages) {
                    setLockedPackage(null);
					setTimeout(() => checkMainPackage(), 0);
                }
            }
        }
        
        return updated;
    });
    setCompletedSelections(completed => completed.filter((_, i) => i !== idx));
};


    // Handle when a TurnosSignUpSelection is completed
    const handleSelectionComplete = (idx: number, data: any, isExtra?: boolean) => {
        setCompletedSelections(prev => {
            if (isExtra) {
                return [...prev, data];
            } else {
                const updated = [...prev];
                updated[idx] = data;
                return updated;
            }
        });
    };

    const handleFocusPackageSelect = () => {
        packageSelectRef.current?.focus();
        packageSelectRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        packageSelectRef.current?.classList.add('animate-bounce');
        setTimeout(() => {
            packageSelectRef.current?.classList.remove('animate-bounce');
        }, 700);
    };

    const handleFocusSideEventSelect = () => {
        SideEventSelectRef.current?.focus();
        SideEventSelectRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        SideEventSelectRef.current?.classList.add('animate-bounce');
        setTimeout(() => {
            SideEventSelectRef.current?.classList.remove('animate-bounce');
        }, 700);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
            {/* Header */}
            <div className="bg-white shadow-2xl border-b-4 border-gray-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
                        <div className="flex items-center gap-6">
                            <div className="bg-gray-50 rounded-2xl p-4 shadow-inner">
                                <img 
                                    src="/logo.avif" 
                                    alt="Logo" 
                                    className="w-20 h-20 sm:w-28 sm:h-28 object-contain"
                                />
                            </div>
                            <div>
                                <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">{jugador.NOMBRECOMPLETO}</h1>
                                <p className="text-gray-600 text-base sm:text-lg mt-1">TAT ID: {jugador.FICHANAL}</p>
                                <p className="text-gray-600 text-base sm:text-lg">{jugador.EMAIL} | {jugador.CITY}, {jugador.ESTADOCORTO}</p>
                            </div>
                        </div>
                        <button
                            onClick={() => navigate(-1)}
                            className="self-start sm:self-auto bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition flex items-center gap-2 shadow-lg text-lg"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                            Back
                        </button>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <div className="flex flex-col gap-8 items-start">
                    {/* Selection Form */}
                    <div className="bg-white shadow-2xl rounded-3xl p-6 sm:p-8 max-w-2xl w-full self-start border-t-4 border-blue-600">
                        {/* Tournament Title */}
                        <div className="mb-8 pb-6 border-b-2 border-gray-200">
                            <div className="flex items-center gap-3 mb-3">
                                <div className="bg-blue-600 rounded-full p-2">
                                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                                    </svg>
                                </div>
                                <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">{tournament.nombre}</h2>
                            </div>
                            <p className="text-gray-600 text-sm sm:text-base ml-14">Follow the steps below to complete your registration</p>
                        </div>

                        {/* Step 1: Group Code */}
                        <div className="mb-8">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="bg-purple-100 text-purple-700 rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">1</div>
                                <label className="block text-gray-900 font-bold text-lg">Group Code <span className="text-gray-500 text-sm font-normal">(Optional)</span></label>
                            </div>
                            <div className="ml-11">
                                <input
                                    type="text"
                                    value={groupCode}
                                    onChange={(e) => setGroupCode(e.target.value)}
                                    placeholder="Enter group code to reveal special packages"
                                    className="w-full border-2 border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition text-lg"
                                />
                                {groupCode && (
                                    <div className="mt-2 flex items-center gap-2 text-green-600">
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                        <span className="text-sm font-semibold">Group packages unlocked!</span>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Step 2: Division */}
                        <div className="mb-8">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="bg-blue-100 text-blue-700 rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">2</div>
                                <label className="block text-gray-900 font-bold text-lg">Select Division</label>
                            </div>
                            <div className="ml-11">
                                <select
                                    className="w-full border-2 border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition text-lg disabled:bg-gray-100 disabled:cursor-not-allowed"
                                    value={selectedDivision}
                                    onChange={e => setSelectedDivision(e.target.value)}
                                    disabled={!!lockedDivision}
                                >
                                    <option value="">-- Choose your division --</option>
                                    {divisiones.map((d: any) => (
                                        <option key={d.CLAVE} value={d.CLAVE}>
                                            {d.DESCRIPCION}
                                        </option>
                                    ))}
                                </select>
                                {lockedDivision && (
                                    <div className="mt-2 flex items-center gap-2 text-blue-600">
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                                        </svg>
                                        <span className="text-sm font-semibold">Division locked: {lockedDivision.DESCRIPCION}</span>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Step 3: Package Selection */}
                        <div className="mb-8">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="bg-green-100 text-green-700 rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">3</div>
                                <label className="block text-gray-900 font-bold text-lg">Select Package Type</label>
                            </div>
                            <div className="ml-11">
                                <p className="text-sm text-gray-600 mb-4 bg-blue-50 p-3 rounded-lg border border-blue-200">
                                    <span className="font-semibold text-blue-900">💡 Tip:</span> Start with a main package, then add re-entries or side events as needed.
                                </p>
                                <div className="mb-4">
                                    <label className=" bg-blue-100 text-blue-700 px-2 mb-2 rounded font-medium text-base">Main Package</label>
                                    <select
                                        className="w-full border-2 border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition text-base disabled:bg-gray-100 disabled:cursor-not-allowed"
                                        disabled={!!selectedItem || !!selectedSideEvent || !!lockedPackage}
                                        value={selectedPackage}
                                        onChange={e => {
                                            setSelectedPackage(e.target.value);
                                            if (e.target.value) animateAddToCartButton();
                                        }}
                                    >
                                        <option value="">-- Choose a package --</option>
                                        {paquetes.map((p: any) => (
                                            <option key={p.CLAVE} value={p.CLAVE}>
                                                {p.DESCRIPCION} {p.COSTO ? `($${p.COSTO})` : ''}
                                            </option>
                                        ))}
                                    </select>
                                    {lockedPackage?.reason && (
                                        <div className="mt-2 flex items-center gap-2 text-amber-600 bg-amber-50 p-2 rounded-lg">
                                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                            </svg>
                                            <span className="text-sm font-semibold">Player already has main package. Proceed with purchasing re-entries and/or side events.</span>
                                        </div>
                                    )}
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    {/* Re-entries */}
                                    <div>
                                        <label className="block text-gray-700 mb-2 font-medium text-base flex items-center gap-2">
                                            <span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs font-bold">RE-ENTRY</span>
                                            Re-entries
                                        </label>
                                        <select
                                            ref={packageSelectRef}
                                            className="w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition disabled:bg-gray-100 disabled:cursor-not-allowed"
                                            disabled={!!selectedPackage || !!selectedSideEvent}
                                            value={selectedItem}
                                            onChange={e => {
                                                setSelectedItem(e.target.value);
                                                if (e.target.value) animateAddToCartButton();
                                            }}
                                        >
                                            <option value="">-- Choose re-entry --</option>
                                            {reEntries.map((p: any) => (
                                                <option key={p.CLAVE} value={p.CLAVE}>
                                                    {p.DESCRIPCION} {p.COSTO ? `($${p.COSTO})` : ''}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    {/* Side Events */}
                                    <div>
                                        <label className="block text-gray-700 mb-2 font-medium text-base flex items-center gap-2">
                                            <span className="bg-yellow-100 text-yellow-700 px-2 py-1 rounded text-xs font-bold">SIDE EVENT</span>
                                            Side Events
                                        </label>
                                        <select
                                            ref={SideEventSelectRef}
                                            className="w-full border-2 border-gray-300 rounded-lg px-3 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 transition disabled:bg-gray-100 disabled:cursor-not-allowed"
                                            disabled={!!selectedPackage || !!selectedItem}
                                            value={selectedSideEvent}
                                            onChange={e => {
                                                setSelectedSideEvent(e.target.value);
                                                if (e.target.value) animateAddToCartButton();
                                            }}
                                        >
                                            <option value="">-- Choose side event --</option>
                                            {sideEvents.map((p: any) => (
                                                <option key={p.CLAVE} value={p.CLAVE}>
                                                    {p.DESCRIPCION} {p.COSTO ? `($${p.COSTO})` : ''}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Step 4: Add to Cart */}
                        <div className="mt-8 pt-6 border-t-2 border-gray-200">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="bg-pink-100 text-pink-700 rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">4</div>
                                <label className="block text-gray-900 font-bold text-lg">Add to Your Cart</label>
                            </div>
                            <div className="ml-11">
                                <button
                                    className={
                                        `w-full px-6 py-4 rounded-xl font-bold text-lg transition-all duration-300 flex items-center justify-center gap-3 shadow-lg
                                        ${!selectedDivision || (!selectedPackage && !selectedItem && !selectedSideEvent) || (!!lockedDivision && selectedDivision !== String(lockedDivision.CLAVE))
                                            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                            : 'bg-gradient-to-r from-green-500 to-green-600 text-white hover:from-green-600 hover:to-green-700 hover:shadow-xl hover:scale-102 cursor-pointer'
                                        }
                                        ${shouldAnimateAddButton ? 'animate-pulse ring-4 ring-green-300' : ''}`
                                    }
                                    onClick={handleAddSelection}
                                    disabled={
                                        !selectedDivision ||
                                        (!selectedPackage && !selectedItem && !selectedSideEvent) ||
                                        (!!lockedDivision && selectedDivision !== String(lockedDivision.CLAVE))
                                    }
                                >
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                                    </svg>
                                    Add Package to Cart
                                </button>
                                {(!selectedDivision || (!selectedPackage && !selectedItem && !selectedSideEvent)) && (
                                    <div className="mt-3 flex items-start gap-2 text-red-600 bg-red-50 p-3 rounded-lg">
                                        <svg className="w-5 h-5 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                        </svg>
                                        <span className="text-sm font-medium">Complete all steps above to add to cart</span>
                                    </div>
                                )}
                            </div>
                        </div>
                </div>
                {/* Render a TurnosSignUpSelection for each selection */}
                {selections.map((sel, idx) => {
                    // Collect all selected turno IDs from other completed selections
                    const otherTurnos = completedSelections
                        .filter((_, i) => i !== idx)
                        .flatMap(pkg => pkg.eventos.flatMap((ev: { turnosInfo: any[] }) => ev.turnosInfo))
                        .map(t => t.CLAVE);
                    return (
                        <div
                            ref={el => selectionRefs.current[idx] = el}
                            key={idx}
                        >
                            <TurnosSignUpSelection
                                key={idx}
                                jugador={jugador}
                                tournament={tournament}
                                discountCode={discountCode}
                                division={sel.division}
                                paquete={sel.package}
                                onSelectionComplete={data => handleSelectionComplete(idx, data)}
                                onRemove={() => handleRemoveSelection(idx)}
                                usedTurnos={otherTurnos}
                                onAddExtraPackageClick={handleFocusPackageSelect}
                                onAddSideEventClick={handleFocusSideEventSelect}
                                index={idx}
                            />
                        </div>
                    );
                })}
                {/* Show checkout button only when all selections are completed */}
                {completedSelections.length === selections.length && selections.length > 0 && (
                    <button
                        className="fixed bottom-6 right-6 z-50 px-8 py-4 rounded-full font-bold text-lg bg-pink-600 hover:bg-pink-700 text-white shadow-2xl hover:shadow-pink-500/50 transition-all duration-300 hover:scale-110 animate-bounce flex items-center gap-3 sm:bottom-8 sm:right-8"
                        onClick={() => {
                            navigate('/checkout', { state: { tournament, player: jugador, packages: completedSelections, ...(recruiterMode ? { recruiterMode: true } : {}) } });
                        }}
                        ref={checkoutButtonRef}
                        style={{ animationIterationCount: '3' }}
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                        </svg>
                        <span className="hidden sm:inline">Go to Checkout</span>
                        <span className="sm:hidden">Checkout</span>
                        <span className="absolute -top-2 -right-2 bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold shadow-lg">
                            {completedSelections.length}
                        </span>
                    </button>
                )}
                </div>
            </div>
        </div>
    );
};

export default TurnosSignUp;